import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button/Button';
import Panel from 'components/Panel/Panel';
import PanelHeader from 'components/PanelHeader/PanelHeader';

import CreditCardCheck36 from 'icons/CreditCardCheck36';
import EventRepeat36 from 'icons/EventRepeat36';

import styles from '../create-page.scss';

function PageTypeCard(props) {
    const { title, description, recurrent, onSelect } = props;

    function handleSelect() {
        if (typeof onSelect === 'function') {
            onSelect(recurrent);
        }
    }

    return (
        <div className={styles.pageTypeCard}>
            <div className={styles.icon}>{recurrent ? <EventRepeat36 /> : <CreditCardCheck36 />}</div>
            <h2 className={styles.title}>{title}</h2>
            <p className={styles.description}>{description}</p>
            <div className={styles.actions}>
                <Button text="Продолжить" onClick={handleSelect} />
            </div>
        </div>
    );
}

export default function SelectPageType(props) {
    const { onSelect, onBackClick } = props;

    return (
        <Panel
            fill={true}
            header={<PanelHeader title={'Выберите тип продукта'} onBackClick={onBackClick} back={true} />}
        >
            <div className={styles.pageTypes}>
                <PageTypeCard
                    title={'Подписка'}
                    description={'Деньги списываются автоматически, согласно составленному графику платежей.'}
                    onSelect={onSelect}
                    recurrent={true}
                />
                <PageTypeCard
                    title={'Один платёж'}
                    description={'Деньги списываются один раз. Платёж сохраняется в профиле клиента.'}
                    onSelect={onSelect}
                />
            </div>
        </Panel>
    );
}

PageTypeCard.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    recurrent: PropTypes.bool,
    onSelect: PropTypes.func,
};

SelectPageType.propTypes = {
    /**
     * Callback triggered on page type selected.
     */
    onSelect: PropTypes.func,
    onBackClick: PropTypes.func,
};
